/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * @private
 * @typedef {import('../../startup/startup-manager').StartupManager} StartupManager
 */

/**
 * Správce spuštění pro standardní webové technologie.
 * @implements {StartupManager}
 */
class WebStartupManager {
  /** @type {StartupManager['destroy']} */
  destroy() {
    // Prázdná metoda pro splnění rozhraní.
  }

  /** @type {StartupManager['start']} */
  start() {
    // Prázná metoda pro splnění rozhraní.
    return Promise.resolve();
  }
}

export default WebStartupManager;
